import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';
import Achievement from '@/views/Achievements/List.vue';
import AchievementDetail from '@/views/Achievements/Details.vue';

export default {
  path: '/achievements',
  component: Layout,
	name: 'Achievements',
  meta: { title: 'achievements', root: true },
  children: [
		{
			path: '/achievements',
			component: Achievement,
			meta: { title: 'achievements', auth: AUTH_KEYS.ACHIEVEMENTS, isHide: true },
		},
		{
			path: '/achievements/detail',
			component: AchievementDetail,
			meta: { title: 'achievement_details', auth: AUTH_KEYS.ACHIEVEMENTS, isHide: true },
		}
	]
};
